class MoviePlayer{
    constructor( _option ){
        this.option = {
            url: '',
            parentNode: '',
            selector: '',
            id: '',
            imgUrl: '',
            movieW: 640,
            movieH: 360,
            videoControl: 'autoplay="true" loop="true" preload="auto"',
            videoType: '',
            isBgType: false,
            styleOption: 'position:absolute;top:0;left:0;',
            stateCallback: ()=>{}
        };

        $.extend(true, this.option, _option);

        let videoUrl = this.option.url;
        let suffix = videoUrl.substring( videoUrl.lastIndexOf( '.' , videoUrl.length ) ).toLowerCase();

        this.isCanPlayType = !!document.createElement( 'video' ).canPlayType;
        this.parent = this.option.parentNode;
        this.option.videoType = ( suffix !== '.webm' )? 'video/mp4': 'video/webm';
        this.node = jQuery( this.makeTemplete() );
        this.vNode = this.node[ 0 ];
        this.parent.append( this.node );

        this.addEvents();
    }

    makeTemplete(){
        if( this.isCanPlayType ){
            return `
                <video id="${this.option.id}" class="${this.option.selector}" ${this.option.videoControl} style="${this.option.styleOption}">
                    <source src="${this.option.url}" type="${this.option.videoType}" />
                </video>`;
        }else{
            return `<img src="${this.option.imgUrl}" />`;
        }
    }

    addEvents() {
        if (this.option.isBgType) {
            let $window = jQuery( window );
            let movieW = this.option.movieW;
            let movieH = this.option.movieH;
            let movImg = this.parent.find('img');
            this.timer = null;
            
            $window.on( 'resize', (ev)=>{
                if(this.timer){
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(() => {
                    let winWidth = $window.width();
                    let winHeight = $window.height();
                    let fixSizeW = winWidth;
                    let fixSizeH = parseInt(( winWidth / movieW ) * movieH);
        
                    if (fixSizeH < winHeight) {
                        fixSizeW = parseInt(( winHeight / movieH ) * movieW);
                        fixSizeH = winHeight;
                    }
        
                    this.node.width( fixSizeW ).height( fixSizeH );
                    if(movImg) movImg.width( fixSizeW ).height( fixSizeH );
        
                    this.parent.css({left: Math.round((winWidth-fixSizeW)/2), top: Math.round(winHeight-fixSizeH)/2});
                }, 500);
            }).trigger( 'resize' );
        }

        //브라우저의 해당 탭 영역이 보이지 않을 때 영상 재생 멈춤
        jQuery( document ).bind( 'webkitvisibilitychange', ()=>{
            if( !this.isCanPlayType ) return;
            if ( !window._checkVisibilityChange ) return;
            if ( document[ 'webkitHidden' ] ) {
                this.node.pause();
            } else {
                this.node.play();
            }
        });

        if( !this.isCanPlayType ){
            this.option.stateCallback( 'error' );
            return;
        }

        this.vNode.onplay = ()=> {
            this.option.stateCallback( 'playstart' );
        };

        this.vNode.onended = ()=> {
            this.option.stateCallback( 'ended' );
        };


        this.vNode.ontimeupdate = ()=> {
            this.option.stateCallback( 'timeupdate' );
        };

        this.vNode.onvolumechange = (e)=>{
            this.option.stateCallback( 'volumechange' ,this.vNode.muted);
        }
    }

    setZindex ( zindex ){
        this.option.zindex = zindex;
        this.node.css({'z-index': zindex });
    }

    volume ( _vol ){
        this.vNode.volume = _vol;
    }

    isMute (){
        return this.node.prop( 'muted' );
    }

    setMute ( bool ){
        this.node.prop('muted', bool);
    }

    muteToggle (){
        var bool = ( this.node.prop( 'muted' ) )? false: true;
        this.setMute( bool );
        return bool;
    }

    play (_time){
        if (_time != undefined) this.vNode.currentTime = _time;
        this.vNode.play();
    }

    pause (_time){
        if (_time != undefined) this.vNode.currentTime = _time;
        this.vNode.pause();
    }

    stop (){
        this.vNode.pause();
    }

    toggle (){
        ( this.vNode.paused )? this.vNode.play(): this.vNode.pause();
    }

    srcChange (_src){
        this.node.find('source').attr('src', _src);
        this.vNode.load();
        this.vNode.play();
    }

}


export default MoviePlayer;